import { checkEnterpriseId, customizeError, getResponseData } from "@helpers/_functions";
import BaseService from "./base.service";
import http from "../http-common";

class WorkingHoursFlagService extends BaseService {
  constructor() {
    super("working-hours-flags");
  }

  getAllByEnterprise(enterpriseId) {
    enterpriseId = checkEnterpriseId(enterpriseId);
    return http
      .get(`${this.path}/list/${enterpriseId}`)
      .then((response) => getResponseData(response));
  }

  create(data) {
    return super
      .insert(data)
      .then((response) => getResponseData(response))
      .catch((err) => Promise.reject(customizeError(err)));
  }

  update(data) {
    return super
      .updateById(data)
      .then((response) => getResponseData(response))
      .catch((err) => Promise.reject(customizeError(err)));
  }

  deleteById(id) {
    return super
      .deleteById(id)
      .then((response) => getResponseData(response))
      .catch((err) => Promise.reject(customizeError(err)));
  }
}

export default new WorkingHoursFlagService();
